import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IPrivacy_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IPrivacy_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class Privacy_ScreenBase extends React.PureComponent<
  IPrivacy_ScreenProps,
  any
> {
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "2d466db7-b100-4364-8b85-39e8d9d51d28",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 391087,
          PropertyName: "value",
          Value:
            "PRIVACY POLICY (EN) Effective Date: May 8, 2026 This Privacy Policy explains how personal data is collected, used, and protected within the Pastel Design Patron Uygulaması (“Application”).",
        },
        {
          Id: 886087,
          PropertyName: "value",
          Value:
            "1. Data Controller Personal data is processed by: *Pastel Design Boss Screen*",
        },
        {
          Id: 141674,
          PropertyName: "value",
          Value:
            "2. Data Collected The Application may collect the following categories of data:",
        },
        {
          Id: 893079,
          PropertyName: "value",
          Value:
            "2.1 Identity and User Information - Name and surname   - Username   - Company / customer information",
        },
        {
          Id: 873269,
          PropertyName: "value",
          Value:
            "2.2 Transaction Data - Order information   - Invoice and payment transactions   - Stock and inventory movements   - ERP integration data",
        },
        {
          Id: 253292,
          PropertyName: "value",
          Value:
            "2.3 Technical Data - IP address   - Device information   - Session data (SessionID, etc.)   - Log records",
        },
        {
          Id: 302304,
          PropertyName: "value",
          Value:
            "3. Purpose of Data Processing Collected data is processed for the following purposes: - User authentication and authorization   - Managing orders and operational processes   - ERP system integration   - Ensuring system security and performance   - Compliance with legal obligations",
        },
        {
          Id: 703443,
          PropertyName: "value",
          Value:
            "4. Data Sharing Personal data may be shared: - With ERP systems and infrastructure providers   - With authorized public authorities when required by law   No data is shared with third parties for commercial purposes.",
        },
        {
          Id: 565624,
          PropertyName: "value",
          Value:
            "5. Data Retention Data is retained: - During the service period   - In accordance with legal retention requirements   After this period, data is deleted or anonymized.",
        },
        {
          Id: 468179,
          PropertyName: "value",
          Value:
            "6. Data Security - Secure data transmission via SSL/TLS   - Access control and authorization mechanisms   - Server and database security measures",
        },
        {
          Id: 441462,
          PropertyName: "value",
          Value:
            "7. User Rights Users have the right to: - Access their personal data   - Request correction   - Request deletion",
        },
        {
          Id: 486025,
          PropertyName: "value",
          Value:
            "8. Cookies and Session Management The Application uses technical data for session management and security purposes only.",
        },
        {
          Id: 737109,
          PropertyName: "value",
          Value:
            "9. Policy Updates This policy may be updated when necessary. Updates become effective upon publication.",
        },
        {
          Id: 333732,
          PropertyName: "value",
          Value: "10. Contact Email: mert@detayyazilim.net",
        },
        {
          Id: 691830,
          PropertyName: "value",
          Value:
            "GİZLİLİK POLİTİKASI (TR) Bu Gizlilik Politikası, Pastel Design Patron Uygulaması (“Uygulama”) kapsamında elde edilen kişisel verilerin işlenmesine ilişkin esasları açıklamaktadır.",
        },
        {
          Id: 476250,
          PropertyName: "value",
          Value:
            "1. Veri Sorumlusu 1. Veri Sorumlusu Bu uygulama kapsamında kişisel veriler, veri sorumlusu sıfatıyla: *Pastel Design Patron Ekranı* tarafından işlenmektedir.",
        },
        {
          Id: 461516,
          PropertyName: "value",
          Value:
            "2. Toplanan Veriler Uygulama kullanımınız sırasında aşağıdaki veri kategorileri toplanabilir:",
        },
        {
          Id: 148568,
          PropertyName: "value",
          Value:
            "2.1 Kimlik ve Kullanıcı Bilgileri - Ad, soyad   - Kullanıcı adı   - Firma / müşteri bilgileri",
        },
        {
          Id: 12691,
          PropertyName: "value",
          Value:
            "2.2 İşlem Verileri - Sipariş bilgileri   - Fatura ve tahsilat işlemleri   - Stok hareketleri   - ERP entegrasyon verileri",
        },
        {
          Id: 676732,
          PropertyName: "value",
          Value:
            "2.3 Teknik Veriler - IP adresi   - Cihaz bilgileri   - Oturum bilgileri (SessionID vb.)   - Log kayıtları",
        },
        {
          Id: 209415,
          PropertyName: "value",
          Value:
            "3. Verilerin İşlenme Amaçları Toplanan veriler aşağıdaki amaçlarla işlenmektedir: - Kimlik doğrulama ve yetkilendirme   - Sipariş ve operasyon süreçlerinin yönetimi   - ERP entegrasyonu   - Sistem güvenliği ve performans izleme   - Yasal yükümlülüklerin yerine getirilmesi",
        },
        {
          Id: 266152,
          PropertyName: "value",
          Value:
            "4. Veri Aktarımı Kişisel veriler: - ERP sistemleri ve teknik altyapı sağlayıcıları ile sınırlı olarak paylaşılabilir   - Yasal zorunluluklar kapsamında yetkili kurumlara aktarılabilir   - Ticari amaçla üçüncü taraflara aktarılmaz",
        },
        {
          Id: 894728,
          PropertyName: "value",
          Value:
            "5. Veri Saklama Süresi Veriler: - Hizmet süresi boyunca   - Yasal saklama süreleri kapsamında   saklanır ve süre sonunda silinir veya anonim hale getirilir.",
        },
        {
          Id: 991846,
          PropertyName: "value",
          Value:
            "6. Veri Güvenliği - SSL/TLS ile güvenli veri iletimi sağlanır   - Yetkilendirme ve erişim kontrolü uygulanır   - Sunucu ve veri güvenliği sağlanır",
        },
        {
          Id: 167481,
          PropertyName: "value",
          Value:
            "7. Kullanıcı Hakları Kullanıcılar: - Verilerine erişme   - Düzeltme talep etme   - Silinmesini talep etme   haklarına sahiptir.",
        },
        {
          Id: 55823,
          PropertyName: "value",
          Value:
            "8. Çerez ve Oturum Yönetimi Uygulama, oturum yönetimi için gerekli teknik verileri kullanır.",
        },
        {
          Id: 527942,
          PropertyName: "value",
          Value:
            "9. Politika Güncellemeleri Bu politika güncellenebilir ve değişiklikler yayınlandığı tarihte yürürlüğe girer.",
        },
        {
          Id: 37928,
          PropertyName: "value",
          Value: "10. İletişim E-posta: mert@detayyazilim.net",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("privacy", "");
      return;
    }

    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("privacy", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("privacy", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
